export const buildProvenance = { "commitHash": "84a8fdef412e70a770a833bf5c69c93e318fc7de", "branchName": "refs/heads/release/2025.4", "buildDate": "2025-12-11T00:06:35.348Z", "version": "2025.4.10250" };
